import { formatPrice } from '../utils/formatPrice';
import { buildBreakdownRows } from '../utils/orderBreakdown';
import './PriceBreakdown.css';

// Shared price-breakdown row list. Accepts either pre-built `rows` (e.g. from a
// persisted order snapshot via buildBreakdownRows) or the breakdown params to
// build them. Renders semantic label/value rows styled by kind (discount,
// shipping, balance, rounding) — the same row set order emails / the invoice
// PDF / the checkout engine show.
export default function PriceBreakdown({
  rows = null,
  t,
  freeLabel,
  containerClass = 'price-breakdown',
  total = null,
  totalLabel,
  ...breakdown
}) {
  const resolved = rows ?? buildBreakdownRows({ t, ...breakdown });
  if ((!resolved || resolved.length === 0) && total == null) return null;

  return (
    <div className={containerClass} aria-live="polite">
      {resolved.map((row) => {
        const isFreeShipping = row.kind === 'shipping' && row.free;
        const isBalanceDue = row.kind === 'balance' && row.sign > 0;
        let value;
        if (isFreeShipping) {
          value = freeLabel ?? t('free', 'FREE');
        } else {
          const isPlain = row.kind === 'subtotal' || row.kind === 'vat';
          const sign = row.sign < 0 ? '−' : (isPlain ? '' : row.sign > 0 ? '+' : '');
          value = `${sign} ${formatPrice(row.amount)}`.trim();
        }
        const classes = [
          'price-breakdown__row',
          `price-breakdown__row--${row.kind}`,
          isFreeShipping ? 'price-breakdown__row--free' : '',
          isBalanceDue ? 'price-breakdown__row--balance-due' : '',
        ].filter(Boolean).join(' ');
        return (
          <div key={row.key} className={classes}>
            <span className="price-breakdown__label">{row.label}</span>
            <span className="price-breakdown__value">{value}</span>
          </div>
        );
      })}
      {total != null && (
        <div className="price-breakdown__row price-breakdown__row--total">
          <span className="price-breakdown__label">{totalLabel ?? t('total', 'Total')}</span>
          <span className="price-breakdown__value">{formatPrice(total)}</span>
        </div>
      )}
    </div>
  );
}
